


import { useEffect, useState } from "react";
import { MediaDisplaySchema } from "./SpotSchema";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { useApiFetch } from "@/helper/apiFetch";
import { useAuth } from "@/auth";
import { useTranslate } from "@/helper/translate";
import { set } from "zod";

export function SpotPreview({ spotId, statusId, onStatusChanged }: { spotId: string; statusId: number, onStatusChanged: (statusId: number, comment: string | null) => void }) {
  const apiFetch = useApiFetch();
  const { translate } = useTranslate();
  const { linkedCustomerId } = useAuth();
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState<MediaDisplaySchema[] | null>(null);
  const [mediaIndex, setIndex] = useState(-1);
  //const [blobURL, setURL] = useState("");
  const [errorText, setError] = useState("");
  const [currentStatusId, setStatus] = useState(statusId);
  const [requestedDeny, setrequestedDeny] = useState(false);
  const [comment, setComment] = useState("Spot Denied");

  const UpdateStatus = async (newStatusId: number) => {


    const res = await apiFetch(`/App/SetSpotStatus?spotId=${spotId}&statusId=${newStatusId}&comment=${newStatusId == 4 ? comment : ""}`, {
      method: "GET",

    });

    if (!res.ok) {
      const e = await res.text();
      setError("Request failed: " + e);

    }
    else {

      setStatus(newStatusId);
      setrequestedDeny(false);
      setError("");
      onStatusChanged(newStatusId, comment);
      
    }



  }

  useEffect(() => {


    apiFetch(`/App/GetSpotPreview?spotId=${spotId}`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then(data => {
        setData(data);
        if (data.length > 0)
          setIndex(0);
        setIsLoaded(true);
      })
      .catch(err => {
        console.error(err);

      });
  }, []);

  useEffect(() => {

    if (mediaIndex < 0)
      return;
    if (!data)
      return;

if(data[mediaIndex].fileData?.startsWith("blob"))
  return;
    
    apiFetch(`/App/ServeMedia/${data[mediaIndex].mediaFileId}`)
      .then(res => {

        if (!res.ok) {
          if (res.status == 404)//probably not converted yet
          {

            data[mediaIndex].fileData = "NOTFOUND";
            setData([...data]);
            return null;

          }
          else
            throw new Error("Failed to fetch");
        }
        return res.blob();
      })
      .then(blob => {
        if (blob != null) {
          data[mediaIndex].fileData = URL.createObjectURL(blob);
          setData([...data]);
        }
        //setURL(URL.createObjectURL(blob));
      })
      .catch(err => {
        console.error(err);

      });
  }, [mediaIndex]);


  return (
    <div>
      {!isLoaded ? (
        <div className="w-full text-center my-10 min-w-[1024px] min-h-[576px]">{translate("common.loading")}</div>
      ) : (
        data && data.length > 0 && (

        <div>
          <div className="!mt-0">

            <div className="tabs">
              {data?.map((media, index) => (
                <span
                  key={index}
                  className={`tab ${index === mediaIndex ? 'active' : ''}`}
                  onClick={() => setIndex(index)}
                >
                  {translate("ui.format")}  {media.aspectRatio ? media.aspectRatio : "N/A"}
                </span>
              ))}
            </div>

            <div >

              <div className="" key={mediaIndex}>


                <div className="min-h-[576px] min-w-[1024px]">
                  {(data[mediaIndex].fileData ?? "") == "NOTFOUND" ? (
                    <div className="p-5 text-center text-gray-500">
                      {translate("ui.mediaNotAvailableYet")}
                    </div>
                  ) : (
                    data[mediaIndex].fileData && (
                      data[mediaIndex].mimeType?.startsWith("video") ? (

                        <video controls autoPlay
                        key={"video" + mediaIndex}
                          style={{ width: data[mediaIndex].width + 'px' }}
                          preload="metadata"
                        
                          src={data[mediaIndex].fileData }
                        />) : (

                        <img
                          className="w-full  max-h-[70vh] object-contain"
                          //src={`data:image/png;base64,${data[mediaIndex].snapshot}`}
                          src={data[mediaIndex].fileData }

                        />
                      )
                    )
                  )
                  }


                </div>


              </div>
            </div>


          </div>

          {currentStatusId == 2 && !requestedDeny && linkedCustomerId == "Admin" && (
            <div>
              <div className="grid-default">

                <div className="grid-default mt-4">

                  <Button className="w-full" type="button" onClick={() => { setrequestedDeny(true); }}>  {translate("ui.deny")} </Button>

                  <Button className="w-full" type="button" onClick={() => { UpdateStatus(3); }}>   {translate("ui.approve")} </Button>
                </div>
              </div>



            </div>)}

  

          {requestedDeny && linkedCustomerId == "Admin" && (
            <div className=" mt-4">


              <div className="grid gap-2 !grid-cols-4">
                <Input
                  type="text"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  className="col-span-3"
                />
                <Button className="col-span-1" type="button" onClick={() => { UpdateStatus(4); }}>  {translate("ui.deny")} </Button>

              </div>




            </div>)}


          {(errorText != "") && (
            <div className="text-red-500 mt-2">
              {errorText}
            </div>
          )
          }
        </div>



      )



      )}
    </div>
  )
}